import { useNotifications } from '@/features/notifications';
import { StripeError } from '@stripe/stripe-js';

/**
 * TODO: Temporary hook to handle unexpected errors in billing process
 */
export const useHandleBillingError = () => {
  const { addNotification } = useNotifications();

  const handleUnknownError = (message: string, error: Error) => {
    const requestId = (error as any).response?.headers?.get('x-request-id');

    addNotification({
      type: 'unexpected',
      meta: {
        errorType: 'billing',
        errorId: requestId ?? message,
        errorMessage: message + ' - ' + error.name + ': ' + error.message,
      },
    });
  };

  const handleStripeError = (error: StripeError) => {
    addNotification({
      type: 'unexpected',
      meta: {
        errorType: 'stripe',
        errorId: error.type,
        errorMessage: error.code + ': ' + error.message,
      },
    });
  };

  return {
    handleUnknownError,
    handleStripeError,
  };
};
